import React, { useState, useContext, useEffect } from "react";
import { DynamicSelect } from "../../components/DynamicSelect";
import api from '../../services/api';
import Flex from '@react-css/flex';
import Modal from 'react-modal';
import InputMask from 'react-input-mask';
import DatePicker from 'react-datepicker';
import { ToggleSwitch } from "../../components/ToggleSwitch";
import { StyledForm } from "../../styled-components/StyledForm.style";
import TimeSheetDetalhesContext from "../../contexts/TimeSheetDetalhesContext";
import Swal from "sweetalert2";
import Select from 'react-select';
import { pad } from '../../utils/stringUtils';
import * as moment from 'moment'

export const ModalEdit = ({ atividade, atividades, onAfterOpen, onRequestClose, peritosList, isOpen, setIsOpen, loadPage }) => {
    var [descricao, setDescricao] = useState(null);
    const [showAdvanceFood, setAdvanceFood] = useState(false);
    const [discountMeal, setDiscountMeal] = useState(true);
    var [horaFinal, setHoraFinal] = useState(null);
    var [horaInicio, setHoraInicio] = useState(null);
    var [desconto, setDesconto] = useState("00:00");
    var [descontoDecimal, setDescontoDecimal] = useState(null);
    var [idAtividade, setIdAtividade] = useState(null);
    var [atividade, setAtividade] = useState(null);
    var [idPeritos, setPeritosId] = useState([]);
    var [perito, setPerito] = useState([]);
    var [selectedPerito, setselectedPerito] = useState({});
    const [atividadeProBono, setAtividadeProBono] = useState(false);

    const {
        timesheetItemAtividade, idTimesheetItemAtividade, timesheet, dataLancamento, setdataLancamento
    } = useContext(TimeSheetDetalhesContext);

    const style = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: "0px",
            minWidth: '35%',
            overflowY: 'auto',
            minHeight: '45%',
            maxHeight: '90%'
        },
        overlay: {
            zIndex: 9999
        }
    };

    let advanceFood = {
        name: 'advanceFood',
        label: 'Descontar Refeição',
        status: timesheetItemAtividade.lancamento.descontarRefeicao
    };

    let proBono = {
        name: 'proBono',
        label: 'Pro bono',
        status: timesheetItemAtividade.atividade.proBono
    };

    const handleDescricao = (event) => {
        setDescricao(event?.target?.value);
    }

    const getFoodModalToggle = (status) => {
        setAdvanceFood(status);
        setDiscountMeal(status);
    };

    const handleDateChange = (date) => {
        if (!validarData(date)) {
            registrationFailure("Data inválida!")
            return;
        }

        if (validarDataMaiorAtual(date)) {
            registrationFailure("Data não deve ser maior que a data atual!")
            return;
        }

        setdataLancamento(date);
    }

    const handleHoraInicial = (hora) => {
        setHoraInicio(hora);
    }

    const handleHoraFinal = (hora) => {
        setHoraFinal(hora);
    }

    const getAtividade = (atividade) => {
        setAtividade(atividade);
        setIdAtividade(atividade.id);
    }

    const handleDescontoIsEdit = (desconto) => {
        setDesconto(convertDecimalToTime(desconto));
        formatDecimalTime(desconto);
    }

    const handleDesconto = (desconto) => {

        if (!desconto) {
            setDesconto("00:00");
            formatDecimalTime(0);
            return;
        }


        setDesconto(desconto);
        formatDecimalTime(timeStringToDecimalHours(desconto));
    }


    const convertDecimalToTime = (decValue) => {
        if (!decValue) {
            return "00:00";
        }

        const decimalHours = parseFloat(decValue);
        const hours = Math.floor(decimalHours);
        const minutes = Math.round((decimalHours - hours) * 60);
        const formattedHours = String(hours).padStart(2, '0');
        const formattedMinutes = String(minutes).padStart(2, '0');

        return `${formattedHours}:${formattedMinutes}`;
    }

    const timeStringToDecimalHours = (timeString) => {
        if (!timeString) {
            return;
        }

        const [hours, minutes] = timeString.split(':').map(Number);
        const decimalHours = hours + (minutes / 60);
        return decimalHours;
    }

    const formatDecimalTime = (decValue) => {
        if (!decValue) {
            setDescontoDecimal(0);
        }
        setDescontoDecimal(decValue?.toFixed(2)?.replace(".", ",") ?? "");
    }


    const getPeritos = (perito) => {
        if (!perito) return

        setPerito(perito);
        setPeritosId([perito.value]);
    };

    const registrationSuccess = () => {
        Swal.fire({
            title: "Sucesso",
            text: "Atividade editada com sucesso",
            icon: "success",
            confirmButtonText: "OK",
        });
    };

    const registrationFailure = (text = "Ops, ocorreu um erro ao realizar o cadastro. Tente novamente em instantes.") => {
        Swal.fire({
            title: "Atenção",
            text: text,
            icon: "error",
            confirmButtonText: "OK",
        });
    };

    const registrationInformation = () => {
        Swal.fire({
            title: "Informação",
            text: "Preencha todos os campos necessários",
            icon: "info",
            confirmButtonText: "OK",
        });
    };

    const validarDataMaiorAtual = (data) => {
        return moment(data, "YYYY-MM-DD", true).isAfter(moment(), 'day');
    }

    const validarData = (data) => {
        return moment(data, "YYYY-MM-DD", true).isValid();
    }

    const formActivities = async () => {
        let descontofinal = "00:00";

        let payload = {
            idAtividade: idAtividade,
            descricao: descricao,
            dataLancamento: moment(dataLancamento).format('YYYY-MM-DD'),
            timeInicial: horaInicio,
            timeFinal: horaFinal,
            descontarRefeicao: discountMeal,
            timeDesconto: desconto,
            idTimesheetItemAtividade: idTimesheetItemAtividade,
            idUsuario: perito.id,
            proBono: atividadeProBono
        }

        if (idAtividade != null
            && dataLancamento != null
            && horaInicio != null
            && horaFinal != null) {
                
            if (desconto != null) {
                descontofinal = desconto;
            
                // Converte os horários de string para objetos Date para comparação
                const inicio = new Date(`1970-01-01T${horaInicio}:00`);
                const fim = new Date(`1970-01-01T${horaFinal}:00`);
            
                // Define os intervalos de tempo
                const intervalos = [
                    { inicio: new Date("1970-01-01T00:00:00"), fim: new Date("1970-01-01T08:00:00") },
                    { inicio: new Date("1970-01-01T11:00:00"), fim: new Date("1970-01-01T14:00:00") },
                    { inicio: new Date("1970-01-01T18:00:00"), fim: new Date("1970-01-01T22:00:00") }
                ];
            
                // Calcula a duração total da atividade em horas
                const duracaoEmHoras = (fim - inicio) / (1000 * 60 * 60); // Converte de ms para horas
            
                // Verifica se o horário de início ou fim está dentro de algum intervalo
                const dentroDoIntervalo = intervalos.some(intervalo => 
                    (inicio >= intervalo.inicio && inicio < intervalo.fim) || 
                    (fim > intervalo.inicio && fim <= intervalo.fim)
                );
            
                // Se estiver dentro do intervalo, a duração for maior que 4 horas e não houver intervalo (desconto)
                if (dentroDoIntervalo && descontofinal === "00:00" && duracaoEmHoras > 4) {
                    //Lembrete: Atividades lançadas entre 00h-08h, 11h-14h e 18h-22h devem conter um horário de intervalo se ultrapassarem 4 horas
                    await registrationTimeInterval(payload);
                    return;
                }
            }
            

            //Valida hora inicial e final
            var dateInicio = new moment();
            dateInicio.set({
                hour: horaInicio.split(":")[0],
                minute: horaInicio.split(":")[1],
                second: 0
            });

            var dateFim = new moment();
            dateFim.set({
                hour: horaFinal.split(":")[0],
                minute: horaFinal.split(":")[1],
                second: 0
            });
            if (!dateInicio.isBefore(dateFim)) {
                registrationFailure("Hora inicial é maior que hora final!")
                return;
            }

            if (discountMeal) {
                var diferenca = moment.duration(dateFim.diff(dateInicio));
                var horasFinais = diferenca.subtract({
                    'hours': (descontofinal.split(":")[0].replace(/_/g, '0').padStart(2, '0')),
                    'minutes': (descontofinal.split(":")[1].replace(/_/g, '0').padStart(2, '0'))
                })
                if (horasFinais.asHours() < 0) {
                    registrationFailure("Não é possível cadastrar uma atividade com horas negativas!")
                    return;
                }
            }            

            if(atividadeProBono) {                
                mensagemProBono(payload);
            }
            else {
                await salvarAtividade(payload);
            }
        }
        else {
            registrationInformation()
        }
    };

    let atividadesFormatados = [];
    const formatAtividades = () => {
        atividades.map(atividade => {
            var item = {
                "value": atividade.value,
                "id": atividade.key,
                "label": `${atividade.value}`
            };
            atividadesFormatados.push(item);
        });
    }
    formatAtividades()

    let peritosFormatados = [];
    const formatPeritos = () => {
        peritosList.map(perito => {
            var item = {
                "value": perito.idUsuario,
                "id": perito.idUsuario,
                "label": `${perito.nome}`
            };
            peritosFormatados.push(item);
        });
    }
    formatPeritos()

    const getProBonoModalToggle = (status) => {
        setAtividadeProBono(status);
    };

    const mensagemProBono = (payload) => {
        Swal.fire({
            text: "Deseja realmente cadastrar esta atividade como Pro Bono?",
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
        }).then(async (result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                Swal.showLoading()
                await api.put(`Timesheet/atividade`, payload)
                    .then(async (response) => {
                        loadPage();
                        setIsOpen(false);
                        registrationSuccess();
                    })
                    .catch((error) => {
                        registrationFailure(error?.response?.data?.notification?.messageReturn)
                    });
            }
        });
    };

    const salvarAtividade = async (payload) => {
        await api.put(`Timesheet/atividade`, payload)
            .then(async (response) => {
                registrationSuccess();
                onRequestClose(false);
                loadPage();
            })
            .catch((error) => {
                registrationFailure(error.response.data.notification.messageReturn)
            });
    }

    const registrationTimeInterval = async (payload) => {
        const result = await Swal.fire({
            title: "Informação",
            text: "Não possui intervalo para o período informado?",
            icon: "info",
            showDenyButton: true,
            confirmButtonText: "Corrigir",
            denyButtonText: "Salvar sem intervalo",
        });

        if (result.isDenied) {
            if (atividadeProBono) {
                await mensagemProBono(payload);
            } else {
                await salvarAtividade(payload);
            }
        }
    };


    useEffect(() => {
        if (timesheetItemAtividade.atividade.idAtividade > 0) {
            setTimeout(() => {
                var peritoResult = peritosFormatados.filter(function (p) {
                    return p.id == timesheetItemAtividade.perito.idPerito;
                })

                getPeritos(peritoResult[0])
                setselectedPerito(peritoResult[0])

                handleHoraInicial(timesheetItemAtividade.lancamento.horaInicial)
                handleHoraFinal(timesheetItemAtividade.lancamento.horaFinal)
                handleDescricao(timesheetItemAtividade.atividade.descricao)
                handleDescontoIsEdit(timesheetItemAtividade.lancamento.intervaloHoras)
                setDescricao(timesheetItemAtividade.atividade.descricao)
                setAtividadeProBono(timesheetItemAtividade.atividade.proBono)

                getAtividade({
                    value: timesheetItemAtividade.atividade.atividadeNome,
                    id: timesheetItemAtividade.atividade.idAtividade,
                    label: timesheetItemAtividade.atividade.atividadeNome
                })
            }, 100);
        }
    }, [timesheetItemAtividade.atividade]);


    return (
        <Modal
            isOpen={isOpen}
            onAfterOpen={onAfterOpen}
            onRequestClose={onRequestClose}
            contentLabel="Editar Timesheet Atividades"
            style={style}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={false}
        >
            <StyledForm>
                <p className="modal-close" onClick={onRequestClose}>X</p>
            </StyledForm>
            <Flex>
                <Flex.Item className="modal-width">
                    <p className="modal-title">Editar Lançamento de Atividade</p>
                </Flex.Item>
            </Flex>
            <Flex>
                <StyledForm>
                    <Flex>
                        <Flex.Item className="modal-width">
                            <div className="position-relative form-group">
                                <div>
                                    <p className="modal-info">Nº do Timesheet</p>
                                    <p className="modal-info-data"> {timesheet.timesheet.numeroTimesheet} </p>
                                    <p className="modal-info">Lider </p>
                                    <p className="modal-info-data">{timesheet.pericia.liderPericia}  </p>
                                    <p className="modal-info">Segurado </p>
                                    <p className="modal-info-data">{timesheet.disciplina.seguradoNome}  </p>
                                </div>
                            </div>
                        </Flex.Item>
                        <Flex.Item className="modal-width">
                            <div className="position-relative form-group">
                                <p className="modal-title"></p>
                                <div>
                                    <p className="modal-info">Disciplina </p>
                                    <p className="modal-info-data">{timesheet.disciplina.seguradoNome}  </p>
                                    <p className="modal-info">Profissional </p>
                                    <p className="modal-info-data">{timesheetItemAtividade.perito.peritoNome} </p>
                                    <p className="modal-info">Cliente </p>
                                    <p className="modal-info-data">{timesheet.cliente.clienteNome} </p>
                                </div>
                            </div>
                        </Flex.Item>
                    </Flex>
                    <Flex>
                        <Flex.Item className="modal-width">
                            <div className="position-relative form-group">
                                <div className="form-wrapper filter-container">
                                    <div style={{ marginLeft: "0px" }} className="form-container flex-column justify-content-center">
                                        <ToggleSwitch config={proBono} setStatus={(status) => getProBonoModalToggle(status)} />
                                    </div>
                                </div>
                            </div>
                        </Flex.Item>
                    </Flex>
                    <Flex>
                        <Flex.Item className="modal-width">
                            <div style={{ width: '100%' }} className="position-relative form-group">
                                <Select
                                    className="basic-single"
                                    placeholder={'Profissional'}
                                    key={selectedPerito?.id}
                                    defaultValue={[selectedPerito]}
                                    options={peritosFormatados}
                                    onChange={getPeritos}
                                />
                            </div>
                        </Flex.Item>
                    </Flex>
                    <Flex>
                        <div style={{ width: '100%' }} className="position-relative form-group">
                            <Select
                                className="basic-single"
                                placeholder={'Atividade'}
                                options={atividadesFormatados}
                                defaultValue={[atividade]}
                                key={atividade?.id}
                                onChange={getAtividade}
                            />
                        </div>
                    </Flex>
                    <Flex>
                        <div style={{ width: '100%' }} className="position-relative form-group">
                            <textarea rows="3" className="input-form" defaultValue={timesheetItemAtividade.atividade.descricao} placeholder="Descrição" name="descricao" onChange={handleDescricao} />
                        </div>
                    </Flex>
                    <Flex className="edit-atividade-timesheet">
                        <Flex.Item style={{ width: '100%', marginRight: '20px' }} >
                            <div className="position-relative form-group">
                                <DatePicker dateFormat="dd/MM/yyyy" locale="pt-BR" className="input-form" defaultValue={dataLancamento} selected={dataLancamento} onChange={handleDateChange} />
                            </div>
                        </Flex.Item>
                        <div style={{ display: "inline" }}>
                            <Flex.Item style={{ width: '50%', float: "left" }}>
                                <div className="position-relative form-group">
                                    <InputMask autoComplete="off" mask="99:99" type='text' className="input-form" placeholder='Hora Inicial' name='HoraInicial' defaultValue={timesheetItemAtividade.lancamento.horaInicial} onBlur={(event) => handleHoraInicial(event.target.value)} />
                                </div>
                            </Flex.Item>
                            <Flex.Item style={{ width: '50%', float: "left" }} >
                                <div className="position-relative form-group">
                                    <InputMask autoComplete="off" mask="99:99" type='text' className="input-form" placeholder='Hora Final' name='HoraFinal' defaultValue={timesheetItemAtividade.lancamento.horaFinal} onBlur={(event) => handleHoraFinal(event.target.value)} />
                                </div>
                            </Flex.Item>
                        </div>
                    </Flex>
                    <Flex className="edit-atividade-timesheet">
                        <Flex.Item style={{ width: '59%', marginRight: '20px' }}>
                            <div className="form-group">
                                <span id="totalDescHoras" style={{ marginTop: '5px', lineHeight: '45px' }}>Descontar Intervalo</span>
                            </div>
                        </Flex.Item>
                        <div style={{ display: "inline" }}>
                            <Flex.Item style={{ width: '50%', float: "left" }}>
                                <div className="position-relative form-group">
                                    <InputMask autoComplete="off" mask="99:99" type='text' className="input-form" placeholder='Desconto' name='Desconto' value={desconto} defaultValue={convertDecimalToTime(timesheetItemAtividade.lancamento.intervaloHoras)} onChange={(event) => setDesconto(event.target.value)} onBlur={(event) => handleDesconto(event.target.value)} />
                                </div>
                            </Flex.Item>
                            <Flex.Item style={{ width: '50%', float: "left" }}>
                                <div className="position-relative form-group">
                                    <span id="totalDescHoras" style={{ marginTop: '5px', marginLeft: '20px', lineHeight: '45px' }}>{descontoDecimal}</span>
                                </div>
                            </Flex.Item>
                        </div>
                    </Flex>
                    <Flex className="full-width">
                        <Flex.Item className="modal-width">
                            <div className="position-relative form-group modal-align-center">
                                <input className='default-button-red' value='Salvar' type="button" onClick={formActivities} />
                            </div>
                        </Flex.Item>
                    </Flex>
                </StyledForm>
            </Flex>
        </Modal>
    );
};